import { render, staticRenderFns } from "./BiddersEdit.vue?vue&type=template&id=7c50bd4e&"
import script from "./BiddersEdit.vue?vue&type=script&lang=js&"
export * from "./BiddersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports